import React from 'react';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function FadeIn({
  children,
  className = ''
}: FadeInProps) {
  return <div className={className} data-id="element-44" data-mp="30d093srpbqug">{children}</div>;
}